import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { UserService } from "../../../shared";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { GMap } from "../bus-tracker-main-map/shared/gmap";
import { BTDistrictSettingsRequest } from "./shared/BTDistrictSettingsRequest";
import { BTSchoolSettingsRequest } from "./shared/BTSchoolSettingsRequest";
import { BTSUSettingsRequest } from "./shared/BTSUSettingsRequest";
import { BTUserSettingsRequest } from "./shared/BTUserSettingsRequest";
import { DataService_BusTrackerSettings } from "./shared/data.service";

@Component({
	selector: "app-bus-tracker-settings",
	templateUrl: "./bus-tracker-settings.component.html",
	styleUrls: ["./bus-tracker-settings.component.css"],
})
export class BusTrackerSettingsComponent implements OnInit {
	constructor(
		private userService: UserService,
		private busService: DataService_BusTrackerSettings,
		private selectService: SchoolselectorService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadDistrictAndUserData();

		if (this.IsSU()) {
			this.loadSUData();
		}

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	////////////////////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////////////////////

	subscription: any;
	overlays: any = [];
	user: any;
	Processing: boolean = false;

	//
	// School
	//

	@ViewChild("SchoolMap")
	schoolRef: GMap;

	SchoolLoading: boolean = true;
	SchoolData: any;
	School: any;

	SchoolHideStudentID: boolean = false;
	SchoolFirstName: boolean = false;
	SchoolLastName: boolean = false;
	SchoolHideBusPosition: boolean = false;
	SchoolHideStudentSwipeOn: boolean = false;
	SchoolHideStudentSwipeOff: boolean = false;
	SchoolLat: any;
	SchoolLong: any;
	SchoolZoom: any;
	SchoolMapExpand: boolean = false;
	ShowSchoolMap: boolean = false;
	SchoolOptions: any;

	//
	// District
	//

	@ViewChild("DistrictMap")
	districtRef: GMap;

	DistrictLoading: boolean = true;
	DistrictData: any;

	DistrictHideStudentID: boolean = false;
	DistrictFirstName: boolean = false;
	DistrictLastName: boolean = false;
	DistrictHideBusPosition: boolean = false;
	DistrictHideStudentSwipeOn: boolean = false;
	DistrictHideStudentSwipeOff: boolean = false;
	DistrictLat: any;
	DistrictLong: any;
	DistrictZoom: any;
	DistrictMapExpand: boolean = false;
	ShowDistrictMap: boolean = false;
	DistrictOptions: any;

	OutOfDateEmailEnabled: any = false;
	OutOfDateHours: any = 0;
	ErrorEmailList: any = "";

	//
	// User
	//
	UserLat: any;
	UserLong: any;
	UserZoom: any;
	UserMapExpand: boolean = false;
	ShowUserMap: boolean = false;
	UserOptions: any;

	@ViewChild("UserMap")
	userRef: GMap;

	//
	// SU
	//

	SULoading: boolean = true;
	SoundLoading: boolean = true;
	SUData: any;
	HideString: any = "";
	HideStringHalf: any = "";

	lstSounds: any = [];
	AccidentHighSound: any = null;
	HighSeveritySound: any = null;
	MediumSeveritySound: any = null;
	LowSeveritySound: any = null;

	////////////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////////////////////////////////

	loadSchoolData() {
		this.SchoolLoading = true;
		this.ShowSchoolMap = false;

		if (this.School == undefined) {
			this.SchoolLoading = false;
			return;
		}

		var result = this.busService.BusTrackerSchoolSettingsSelect(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.SchoolData = response[0];

				this.SchoolHideStudentID = this.SchoolData.SchoolHideStudentID;
				this.SchoolFirstName = this.SchoolData.SchoolHideStudentFirstName;
				this.SchoolLastName = this.SchoolData.SchoolHideStudentLastName;
				this.SchoolHideBusPosition = this.SchoolData.SchoolHideBusPositions;
				this.SchoolHideStudentSwipeOn = this.SchoolData.SchoolHideStudentSwipeOn;
				this.SchoolHideStudentSwipeOff = this.SchoolData.SchoolHideStudentSwipeOff;
				this.SchoolLat = this.SchoolData.SchoolDefaultLat;
				this.SchoolLong = this.SchoolData.SchoolDefaultLong;
				this.SchoolZoom = this.SchoolData.SchoolDefaultZoom;

				this.SchoolOptions = {
					center: {
						lat: Number(this.SchoolLat),
						lng: Number(this.SchoolLong),
					},
					zoom: Number(this.SchoolZoom),
				};

				this.ShowSchoolMap = true;

				this.SchoolLoading = false;
			},
			(error) => {
				this.SchoolLoading = false;
			}
		);
	}

	loadDistrictAndUserData() {
		this.DistrictLoading = true;
		this.ShowDistrictMap = false;
		this.ShowUserMap = false;

		var result = this.busService.BusTrackerDistrictAndUserSettingsSelect(this.user.personID);
		result.subscribe(
			(response) => {
				this.DistrictData = response[0];

				this.DistrictHideStudentID = this.DistrictData.DistrictHideStudentID;
				this.DistrictFirstName = this.DistrictData.DistrictHideStudentFirstName;
				this.DistrictLastName = this.DistrictData.DistrictHideStudentLastName;
				this.DistrictHideBusPosition = this.DistrictData.DistrictHideBusPositions;
				this.DistrictHideStudentSwipeOn = this.DistrictData.DistrictHideStudentSwipeOn;
				this.DistrictHideStudentSwipeOff = this.DistrictData.DistrictHideStudentSwipeOff;
				this.DistrictLat = this.DistrictData.DistrictDefaultLat;
				this.DistrictLong = this.DistrictData.DistrictDefaultLong;
				this.DistrictZoom = this.DistrictData.DistrictDefaultZoom;

				this.UserLat = this.DistrictData.UserDefaultLat;
				this.UserLong = this.DistrictData.UserDefaultLong;
				this.UserZoom = this.DistrictData.UserDefaultZoom;

				this.OutOfDateEmailEnabled = this.DistrictData.OutOfDateEmailEnabled;
				this.OutOfDateHours = this.DistrictData.OutOfDateHours;
				this.ErrorEmailList = this.DistrictData.ErrorEmailList;

				this.DistrictOptions = {
					center: {
						lat: Number(this.DistrictLat),
						lng: Number(this.DistrictLong),
					},
					zoom: Number(this.DistrictZoom),
				};

				this.UserOptions = {
					center: {
						lat: Number(this.UserLat),
						lng: Number(this.UserLong),
					},
					zoom: Number(this.UserZoom),
				};

				this.ShowDistrictMap = true;
				this.ShowUserMap = true;

				this.DistrictLoading = false;
			},
			(error) => {
				this.DistrictLoading = false;
			}
		);
	}

	loadSUData() {
		this.SULoading = true;

		var result = this.busService.BusTrackerSUSettingsSelect();
		result.subscribe(
			(response) => {
				this.SUData = response[0];

				this.HideString = this.SUData.HideString;
				this.HideStringHalf = this.SUData.HideStringHalf;

				this.loadSounds();

				this.SULoading = false;
			},
			(error) => {
				this.SULoading = false;
			}
		);
	}

	loadSounds() {
		this.SoundLoading = true;

		var result = this.busService.SoundSelectList();
		result.subscribe(
			(response) => {
				this.lstSounds = response;

				for (var z = 0; z < this.lstSounds.length; z++) {
					var next = this.lstSounds[z];

					if (next.SoundFile == this.SUData.AccidentHighSound) {
						this.AccidentHighSound = next;
					}
					if (next.SoundFile == this.SUData.HighSeveritySound) {
						this.HighSeveritySound = next;
					}
					if (next.SoundFile == this.SUData.MediumSeveritySound) {
						this.MediumSeveritySound = next;
					}
					if (next.SoundFile == this.SUData.LowSeveritySound) {
						this.LowSeveritySound = next;
					}
				}

				this.SoundLoading = false;
			},
			(error) => {
				this.SoundLoading = false;
			}
		);
	}

	////////////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////////////////////////

	onUpdateSchool() {
		this.Processing = true;

		try {
			var lat: any = "0";
			var long: any = "0";
			var zoom: any = this.schoolRef.getMap().getZoom();

			var Center = this.schoolRef.getMap().getCenter();
			lat = Center.lat();
			long = Center.lng();

			let parms: BTSchoolSettingsRequest = {
				SchoolHideStudentID: this.SchoolHideStudentID,
				SchoolHideStudentFirstName: this.SchoolFirstName,
				SchoolHideStudentLastName: this.SchoolLastName,
				SchoolHideBusPositions: this.SchoolHideBusPosition,
				SchoolHideStudentSwipeOn: this.SchoolHideStudentSwipeOn,
				SchoolHideStudentSwipeOff: this.SchoolHideStudentSwipeOff,
				SchoolDefaultLat: lat.toString(),
				SchoolDefaultLong: long.toString(),
				SchoolDefaultZoom: zoom.toString(),
				SchoolID: this.School.SchoolID,
			};

			var result = this.busService.BusTrackerSchoolSettingsUpdate(parms);
			result.subscribe(
				(response) => {
					this.Processing = false;

					if (response) {
						//Success Dialog
						this.confirmationService.confirm({
							key: "school",
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "School-Level Transit Settings were Updated Successfully.",
							header: "Success",
							icon: "fa",
							accept: () => {
								this.loadSchoolData();
							},
						});
					} else {
						//Fail Dialog
						this.confirmationService.confirm({
							key: "school",
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "Could Not Update School-Level Transit Settings",
							header: "ERROR",
							icon: "fa",
							accept: () => {},
						});
					}
				},
				(error) => {}
			);
		} catch (e) {
			e.toString();
			this.Processing = false;
		}
	}

	onResetSchool() {
		this.Processing = true;

		try {
			var result = this.busService.BusTrackerSchoolSettingsReset(this.School.SchoolID);
			result.subscribe(
				(response) => {
					this.Processing = false;

					if (response) {
						//Success Dialog
						this.confirmationService.confirm({
							key: "school",
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "School Transit Settings were reset Successfully.",
							header: "Success",
							icon: "fa",
							accept: () => {
								this.loadSchoolData();
							},
						});
					} else {
						//Fail Dialog
						this.confirmationService.confirm({
							key: "school",
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "Could Not Reset School Transit Settings",
							header: "ERROR",
							icon: "fa",
							accept: () => {},
						});
					}
				},
				(error) => {}
			);
		} catch (e) {
			e.toString();
			this.Processing = false;
		}
	}

	onUpdateDistrict() {
		this.Processing = true;

		try {
			var lat: any = "0";
			var long: any = "0";
			var zoom: any = this.districtRef.getMap().getZoom();

			var Center = this.districtRef.getMap().getCenter();
			lat = Center.lat();
			long = Center.lng();

			let parms: BTDistrictSettingsRequest = {
				HideStudentID: this.DistrictHideStudentID,
				HideStudentFirstName: this.DistrictFirstName,
				HideStudentLastName: this.DistrictLastName,
				HideBusPositions: this.DistrictHideBusPosition,
				HideStudentSwipeOn: this.DistrictHideStudentSwipeOn,
				HideStudentSwipeOff: this.DistrictHideStudentSwipeOff,
				DefaultLat: lat.toString(),
				DefaultLong: long.toString(),
				DefaultZoom: zoom.toString(),
				OutOfDateEmailEnabled: this.OutOfDateEmailEnabled == true ? 1 : 0,
				OutOfDateHours: this.OutOfDateHours,
				ErrorEmailList: this.ErrorEmailList,
			};

			var result = this.busService.BusTrackerDistrictSettingsUpdate(parms);
			result.subscribe(
				(response) => {
					this.Processing = false;

					if (response) {
						//Success Dialog
						this.confirmationService.confirm({
							key: "district",
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "District-Level Transit Settings were Updated Successfully.",
							header: "Success",
							icon: "fa",
							accept: () => {
								this.loadDistrictAndUserData();
							},
						});
					} else {
						//Fail Dialog
						this.confirmationService.confirm({
							key: "district",
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "Could Not Update District-Level Transit Settings",
							header: "ERROR",
							icon: "fa",
							accept: () => {},
						});
					}
				},
				(error) => {}
			);
		} catch (e) {
			e.toString();
			this.Processing = false;
		}
	}

	onUpdateUser() {
		this.Processing = true;

		try {
			var lat: any = "0";
			var long: any = "0";
			var zoom: any = this.userRef.getMap().getZoom();

			var Center = this.userRef.getMap().getCenter();
			lat = Center.lat();
			long = Center.lng();

			let parms: BTUserSettingsRequest = {
				DefaultLat: lat.toString(),
				DefaultLong: long.toString(),
				DefaultZoom: zoom.toString(),
				PersonID: this.user.personID,
			};

			var result = this.busService.BusTrackerUserSettingsUpdate(parms);
			result.subscribe(
				(response) => {
					this.Processing = false;

					if (response) {
						//Success Dialog
						this.confirmationService.confirm({
							key: "user",
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "User Transit Settings were Updated Successfully.",
							header: "Success",
							icon: "fa",
							accept: () => {
								this.loadDistrictAndUserData();
							},
						});
					} else {
						//Fail Dialog
						this.confirmationService.confirm({
							key: "user",
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "Could Not Update User Transit Settings",
							header: "ERROR",
							icon: "fa",
							accept: () => {},
						});
					}
				},
				(error) => {}
			);
		} catch (e) {
			e.toString();
			this.Processing = false;
		}
	}

	onResetUser() {
		this.Processing = true;

		try {
			var result = this.busService.BusTrackerUserSettingsReset(this.user.personID);
			result.subscribe(
				(response) => {
					this.Processing = false;

					if (response) {
						//Success Dialog
						this.confirmationService.confirm({
							key: "user",
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "User Transit Settings were reset Successfully.",
							header: "Success",
							icon: "fa",
							accept: () => {
								this.loadDistrictAndUserData();
							},
						});
					} else {
						//Fail Dialog
						this.confirmationService.confirm({
							key: "user",
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "Could Not Reset User Transit Settings",
							header: "ERROR",
							icon: "fa",
							accept: () => {},
						});
					}
				},
				(error) => {}
			);
		} catch (e) {
			e.toString();
			this.Processing = false;
		}
	}

	onUpdateSU() {
		this.Processing = true;

		try {
			let parms: BTSUSettingsRequest = {
				HideString: this.HideString,
				HideStringHalf: this.HideStringHalf,
				AccidentHighSound: this.AccidentHighSound.SoundFile,
				HighSeveritySound: this.HighSeveritySound.SoundFile,
				MediumSeveritySound: this.MediumSeveritySound.SoundFile,
				LowSeveritySound: this.LowSeveritySound.SoundFile,
			};

			var result = this.busService.BusTrackerSUSettingsUpdate(parms);
			result.subscribe(
				(response) => {
					this.Processing = false;

					if (response) {
						//Success Dialog
						this.confirmationService.confirm({
							key: "user",
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "SU Transit Settings were Updated Successfully.",
							header: "Success",
							icon: "fa",
							accept: () => {
								this.loadSUData();
							},
						});
					} else {
						//Fail Dialog
						this.confirmationService.confirm({
							key: "user",
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "Could Not Update SU Transit Settings",
							header: "ERROR",
							icon: "fa",
							accept: () => {},
						});
					}
				},
				(error) => {}
			);
		} catch (e) {
			e.toString();
			this.Processing = false;
		}
	}

	////////////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////////////////////////////////////
	onSchoolChange(val) {
		this.School = val;

		this.loadSchoolData();
	}
	////////////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////////////////////////////////

	IsSU() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0;
		}
	}

	IsSULoading() {
		return this.SULoading == true || this.SoundLoading == true || this.Processing == true;
	}

	IsSchoolLoading() {
		return this.SchoolLoading == true || this.Processing == true;
	}

	IsDistrictLoading() {
		return this.DistrictLoading == true || this.Processing == true;
	}

	CanEditDistrict() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0 || this.user.UserLevelID == 1;
		}
	}

	////////////////////////////////////////////////////////////////////////////////////
}
